import React from 'react';
import {
  Box,
  Flex,
  Button,
  Input,
  FormControl,
  FormLabel,
} from '@chakra-ui/react';
import './CampaignListCustomModal.css';

const CampaignListCustomModal = ({
  isOpen,
  onClose,
  subjectLine,
  setSubjectLine,
  handleSave,
}) => {
  if (!isOpen) return null;

  return (
    <Box className="modal-overlay">
      <Box className="modal-content">
        <Flex justifyContent="space-between" alignItems="center" mb={4}>
          <Box as="h2">Run Campaign</Box>
          <Button onClick={onClose} className="modal-close-button">
            &times;
          </Button>
        </Flex>
        <Box mb={4}>
          <FormControl>
            <FormLabel>Enter a subject line for your campaign</FormLabel>
            <Input
              placeholder="Subject line"
              value={subjectLine}
              onChange={(e) => setSubjectLine(e.target.value)}
            />
          </FormControl>
        </Box>
        <Flex justifyContent="flex-end">
          <Button colorScheme="blue" mr={3} onClick={handleSave}>
            Save
          </Button>
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
        </Flex>
      </Box>
    </Box>
  );
};

export default CampaignListCustomModal;
